module.exports = __webpack_public_path__ + "static/img/img_7.27a8cc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/code/img_7.jpg
// module id = 114
// module chunks = 20